import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { ShieldCheckIcon, LockIcon } from 'lucide-react';
export function OfferSection() {
  return <section id="offer" className="py-14 bg-white relative overflow-hidden" data-id="element-111">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-full bg-cream rounded-3xl -z-10 transform -skew-y-3" data-id="element-112" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-113">
        <FadeIn data-id="element-114">
          <div className="bg-forest text-white rounded-[2.5rem] p-8 md:p-16 text-center shadow-2xl border-4 border-white" data-id="element-115">
            <ShieldCheckIcon className="w-16 h-16 text-leaf mx-auto mb-6" data-id="element-116" />

            <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-117">
              Recupera el control de la salud de tu familia hoy mismo.
            </h2>

            <p className="text-xl text-cream/90 mb-10 max-w-2xl mx-auto" data-id="element-118">
              Obtén el manual completo, incluyendo el Menú Blindado de 15 días,
              la Guía de Supermercado y el Protocolo de Infiltración.
            </p>

            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 mb-10 max-w-md mx-auto border border-white/20" data-id="element-119">
              <p className="text-cream/80 uppercase tracking-wider text-sm font-bold mb-2" data-id="element-120">
                Inversión Única
              </p>
              <div className="inline-block bg-red-500 text-white text-sm font-bold uppercase tracking-wider px-4 py-1.5 rounded-full mb-4" data-id="element-121">
                73% de descuento
              </div>
              <div className="flex justify-center items-baseline space-x-3" data-id="element-122">
                <span className="text-2xl text-cream/50 font-medium line-through" data-id="element-123">
                  $24
                </span>
                <span className="text-6xl font-extrabold text-white" data-id="element-124">
                  $6.39
                </span>
                <span className="text-xl text-cream/80 font-medium" data-id="element-125">USD</span>
              </div>
            </div>

            <Button variant="primary" href="https://www.novantumnexus.com/cart/53962937205011:1" className="w-full sm:w-auto md:px-12 md:py-5 text-xl shadow-leaf/50 shadow-lg" data-id="element-126">
              QUIERO BLINDAR LA SALUD DE MI HIJO
            </Button>

            <div className="mt-8 flex flex-col items-center space-y-3 text-cream/70 text-sm" data-id="element-127">
              <div className="flex items-center space-x-2" data-id="element-128">
                <LockIcon className="w-4 h-4" data-id="element-129" />
                <span data-id="element-130">Pago 100% seguro y encriptado</span>
              </div>
              <p data-id="element-131">
                Acceso inmediato tras el pago • Formato PDF compatible con
                cualquier dispositivo
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}